// Brevo lead capture for the template download gates.
//
// SETUP (one time, in Brevo):
//   1. Contacts > Lists: create a list, e.g. "Template downloads".
//   2. Contacts > Settings > Contact attributes: add text attributes
//      CENTER_NAME, CAPACITY, TEMPLATE, TEMPLATE_URL (names must match
//      FIELDS below).
//   3. Forms > create a subscription form on that list with those fields.
//      Publish it, choose "Share the HTML code", and copy the value of the
//      form's  action="..."  attribute. It looks like:
//        https://sibforms.com/serve/MUIFAB1234567890abcdef
//      Paste it into FORM_ACTION below.
//   4. Automations > create an automation triggered by "contact added to
//      list" that sends the template email. Use {{ contact.TEMPLATE_URL }}
//      as the download button's link in that one email and every person
//      gets their own file.
//
// NOTE: sibforms does not return CORS headers, so the POST is fire-and-forget
// (mode: "no-cors"). template_downloads.js shows the download link the
// moment the form passes validation, regardless of this call's outcome —
// the file is never held hostage to an email actually arriving.

export const BREVO_CONFIG = {
  FORM_ACTION:
    "https://e07e61c3.sibforms.com/serve/MUIFANP2TBT8LT_7ZdDsQulp7I4MYtG7Xt9oo02VGVmEObUqDvTcFTDrHPpcXZDrcuoIF9OIeTiD0voIOuXBLd5p6w2_72dePiNRJUv0WSHURNf6Owj3nY-TdR_B-8Jfgq3bjaZN4SCggyG38MFHs6ChSD_orSIXLRrARXsj_M9vcjRqyJNx9Fgs0Pd02RrWv4etX_OmgRh9msi0LQ==",
  FIELDS: {
    email: "EMAIL",
    first: "FIRSTNAME",
    last: "LASTNAME",
    center: "CENTER_NAME",
    capacity: "CAPACITY",
    template: "TEMPLATE",
    templateUrl: "TEMPLATE_URL",
  },
  LOCALE: "en",
}

export function submitLead(data) {
  const { FORM_ACTION, FIELDS, LOCALE } = BREVO_CONFIG

  if (!FORM_ACTION || FORM_ACTION.indexOf("sibforms.com") === -1) {
    console.warn("[MCA] Brevo FORM_ACTION not configured — lead not sent:", data)
    return Promise.resolve({ sent: false, reason: "not-configured" })
  }

  const body = new FormData()
  Object.keys(FIELDS).forEach((key) => {
    if (data[key]) body.append(FIELDS[key], data[key])
  })
  body.append("locale", LOCALE)
  body.append("email_address_check", "")
  body.append("html_type", "simple")

  try {
    window.dataLayer?.push({ event: "template_download", template: data.template })
    window.gtag?.("event", "template_download", { template: data.template })
  } catch {
    // Analytics is best-effort — never block the download over it.
  }

  return fetch(FORM_ACTION, { method: "POST", mode: "no-cors", body })
    .then(() => ({ sent: true }))
    .catch((err) => {
      console.warn("[MCA] Brevo submit failed", err)
      return { sent: false, reason: "network" }
    })
}
